<template>
  <div id="dashboard-analytics">
    <div class="flex flex-col gap-4 mb-32">
      <div class="flex flex-wrap gap-3" v-if="$tabHasPermission(permission)">
        <SalesOrdersPerSegmentsChart
          class="md:w-1/3"
          v-if="
            $tabHasPermission('GetSalesOrdersPerSegmentFromFirstOfThisMonth')
          "
        ></SalesOrdersPerSegmentsChart>
        <QuotasPerInventoryChart
          class="md:w-1/2 flex-grow"
          v-if="$tabHasPermission('GetQuotasPerInventoryOfProduct')"
        ></QuotasPerInventoryChart>
        <PackagesStateChart
          class="md:w-1/3"
          v-if="
            $tabHasPermission(
              'GetPackagesStateInfoForDashboardFromFirstOfMonth'
            )
          "
        ></PackagesStateChart>
        <InventoryBalancePerSegmentsChart
          class="md:w-1/2 flex-grow"
          v-if="$tabHasPermission('GetInventoryBalancesForEachSegment')"
        ></InventoryBalancePerSegmentsChart>
      </div>
      <SalesPersonsSalesPerTargetChart
        v-if="
          $tabHasPermission(
            'GetTotalOrdersOfSaleTargetsOfSalePersonsFromFirstOfThisMonth'
          )
        "
      ></SalesPersonsSalesPerTargetChart>
      <div
        class="vx-card m-0 flex-grow"
        v-if="$tabHasPermission('GetAgentInfosOfCurrentUser')"
      >
        <div class="vx-card__body card-body p-2">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div>
                <h5 class="my-4">{{ $t("MyAgents") }}</h5>
              </div>

        <div class="my-4">
          <div class="flex">
            <div class="w-full">
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-left"
                ><div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
        </div>

        <div class="vx-row" v-if="showFilters">
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-1 mt-1">
                <vs-input
                  class="inputx"
                  v-model="gridSearchData.SaleAgentName"
                  :label="$t('AgentName')"
                  @keyup.enter="submitFilter"
                  v-trim-space
                  placeholder="نام نماینده"
                />
              </div>

              <div class="vx-col w-full sm:w-2/2 pt-6">
                <div>
                  <vs-button
                    type="filled"
                    class="float-left"
                    @click.prevent="submitFilter()"
                    >{{ $t("SubmitFilter") }}</vs-button
                  >
                  <vs-button
                    type="filled"
                    class="float-left mr-4"
                    id="reset-btn"
                    @click.prevent="resetForm"
                    >{{ $t("ResetFilter") }}</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

          <div class="vx-row pt-4">
            <div class="vx-col w-full mb-base">
              <data-grid
                class=""
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('Firstname') },
                  { title: $t('PhoneNumber') },
                  { title: $t('HoldersOfTheRightToSignName') },
                  { title: $t('ProvinceAndCityName') },
                  { title: $t('AgentType') },
                  { title: $t('AmountOfOrdersPerSaleTarget') },
                  { title: $t('Action') },
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 20%">
                    <span>{{ row.name }}</span>
                  </td>
                  <td style="width: 20%">
                    <span v-if="row.phoneNumber">{{ row.phoneNumber }}</span>
                    <span v-else>-</span>
                  </td>
                  <td style="width: 20%">
                    <span v-if="row.holdersOfTheRightToSignName">{{ row.holdersOfTheRightToSignName }}</span>
                    <span v-else>-</span>
                  </td>
                  <td style="width: 20%">
                    <span v-if="row.provinceAndCityName">{{ row.provinceAndCityName }}</span>
                    <span v-else>-</span>
                  </td>
                  <td style="width: 20%">
                    <span v-if="row.agentType == '0'">{{ $t("Legal") }}</span>
                    <span v-if="row.agentType == '1'">{{
                      $t("Individual")
                    }}</span>
                  </td>
                  <td style="width: 20%">
                    <div class="w-full h-full flex justify-center">
                      <progress-bar
                        :progress="
                          Math.round(row.totalAmountOfOrderInPercent) || 0
                        "
                        :key="row.agentId"
                        :showNull="row.saleTargetInPercent == 0"
                      ></progress-bar>
                    </div>
                  </td>
                  <td style="width: 20%">
                    <div class="dropdown">
                      <vs-button
                        color="success"
                        type="gradient"
                        icon-pack="feather"
                        class="vx-col w-full d-inline"
                        >{{ $t("Action") }}</vs-button
                      >

                      <div class="dropdown-content">
                        <div class="child-dropdown">
                          <vs-button
                            color="white"
                            type="gradient"
                            class="text-dark"
                            @click.prevent="segmentPopup(row)"
                            >{{ $t("ProductSegments") }}</vs-button
                          >
                        </div>
                        <div class="child-dropdown">
                          <router-link
                            :to="{
                              path: '/AgentQuotas/' + row.agentId,
                              query: {
                                AgentName: row.name,
                              },
                            }"
                          >
                            <vs-button
                              color="white"
                              type="gradient"
                              class="text-dark"
                              >{{ $t("Quota") }}</vs-button
                            >
                          </router-link>
                        </div>
                        <div class="child-dropdown">
                          <router-link
                            v-if="!row.agentId == 0"
                            :to="{
                              path: '/ChannelBaskets/AddBasket',
                              query: {
                                AgentId: row.agentId,
                                AgentName: row.name,
                                ownerUserId: row.ownerUserId,
                              },
                            }"
                          >
                            <vs-button
                              color="white"
                              type="gradient"
                              class="text-dark"
                              >{{ $t("AddOrder") }}</vs-button
                            >
                          </router-link>
                        </div>
                        <div class="child-dropdown">
                          <router-link
                            :to="{
                              path: '/Package/Index',
                              query: {
                                ownerUserId: row.ownerUserId,
                              },
                            }"
                          >
                            <vs-button
                              color="white"
                              type="gradient"
                              class="text-dark"
                              >پیگیری مرسولات</vs-button
                            >
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </td>
                </template>
              </data-grid>

             </div>
            </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <agent-segment-popup
      :show="showAgentSegmentPopup"
      :agentSegmentInfoApi="agentSegmentInfoApi"
      :agentName="agentName"
      @finish="onAgentSegmentModalfinish"
    ></agent-segment-popup>
  </div>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import AgentSegmentPopup from "@/views/sale-management/BasicDefinitions/AssignProductToSegment/DashboardAgentSegmentPopup.vue";
import VueApexCharts from "vue-apexcharts";
import authService from "@/auth/authService";
import Shimmer from "@/components/Shimmer.vue";
import SalesPersonsSalesPerTargetChart from "./SalesPersonsSalesPerTargetChart.vue";
import QuotasPerInventoryChart from "./QuotasPerInventoryChart.vue";
import SalesOrdersPerSegmentsChart from "./SalesOrdersPerSegmentsChart.vue";
import InventoryBalancePerSegmentsChart from "./InventoryBalancePerSegmentsChart.vue";
import PackagesStateChart from "./PackagesStateChart.vue";
import ProgressBar from "./ProgressBar.vue";

export default {
  data() {
    return {
      myAgentsEnabled: false,
      showFilters: false,
      permission: "Dashboard",
      gridDataSource: {
        type: "app",
        service: "Sales/api/SalePersonQuery/current-user/agent-info",
      },
      gridSearchData: {},
      agentLoaded: false,
      showAgentSegmentPopup: false,
      agentSegmentInfoApi: "",
      agentName: "",
      progressOptions: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 15,
          fontFamily: "IranSans",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2f9951",
          backgroundColor: "#eb6f6f",
          inverted: true,
        },
        layout: {
          height: 20,
          width: 140,
          horizontalTextAlign: 58,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line",
        },
      },
      currentUserId: null,
      onlineuserInfo: "",
    };
  },
  async mounted() {
    // var permissionList = localStorage.getItem("permissions").split(",");
    // if (permissionList.includes("GetAgentInfosOfCurrentUser")) {
    //   this.load();
    //   this.gridDataSource = {
    //     type: "app",
    //     service: "Sales/api/SalePersonQuery/current-user/agent-info",
    //   };
    // }
    var userInfo = await authService.getUser();
    this.currentUserId = userInfo.profile.sub;
    // setTimeout(() => {
    //   this.agentLoaded = true;
    // }, 200);
    // axios
    //   .get("https://www.avajang.com/api/onlineuser")
    //   .then((response) => (this.onlineuserInfo = response));
  },
  methods: {
    segmentPopup(model) {
      this.agentSegmentInfoApi =
        "Sales/api/SaleAgentsQuery/" +
        model.agentId +
        "/" +
        this.currentUserId +
        "/SegmentInfos";
      this.agentName = model.name;
      this.showAgentSegmentPopup = true;
    },
    onAgentSegmentModalfinish() {
      this.showAgentSegmentPopup = false;
    },

     submitFilter() {
      debugger;
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        fromDate: "",
        toDate: "",
        itemCode: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },

  },
  components: {
    DataGrid,
    AgentSegmentPopup,
    VueApexCharts,
    Shimmer,
    SalesPersonsSalesPerTargetChart,
    ProgressBar,
    SalesOrdersPerSegmentsChart,
    QuotasPerInventoryChart,
    PackagesStateChart,
    InventoryBalancePerSegmentsChart,
  },
};
</script>
<style scoped></style>
<style>
.dropdown {
  position: relative;
  display: inline-block;
  width: 160px;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  max-width: 160px;
  width: 100%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.dropdown:hover .dropdown-content {
  display: block;
}
.child-dropdown:hover {
  background-color: #ccc;
}
.apexcharts-tooltip-series-group .apexcharts-tooltip-marker {
  margin-left: 8px; /* Adjust the space as needed */
}
.rotate-img {
  transition: transform 0.4s; /* Adjust the duration as needed */
}
.rotate--180deg {
  rotate: -180deg !important;
  transition: transform 0.4s !important;
}
.no-hover {
  pointer-events: none;
}
</style>
